import { Tab as HeadlessTab, TabGroupProps, TabProps } from '@headlessui/react';
import cx from 'classnames';
import React, { ElementType } from 'react';

export const TabGroup = <TTag extends ElementType>({
  children,
  ...props
}: TabGroupProps<TTag>) => {
  return (
    <HeadlessTab.Group {...props}>
      <HeadlessTab.List className="flex gap-3">{children}</HeadlessTab.List>
    </HeadlessTab.Group>
  );
};

export const Tab = <TTag extends ElementType>({
  children,
  ...props
}: TabProps<TTag>) => {
  return (
    <HeadlessTab
      {...props}
      className={({ selected }: { selected: boolean }) =>
        cx(
          'py-2 px-3 rounded-lg outline-none font-inter font-medium break-words text-sm truncate no-underline',
          {
            'bg-active text-blue-500': selected,
            'bg-transparent': !selected,
          },
        )
      }
    >
      {children}
    </HeadlessTab>
  );
};
